import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { getTenant, getTenants } from "../../api";

// Not the worst example for store management I guess, but in this case,
// the listing endpoint doesn't return the full data so we can't cache like
// that...
export const useTenantStore = create(
  immer((set, get) => ({
    tenants: {},
    allTenants: { totalCount: 0, data: [] }, // For listing
    loading: {}, // Track loading state by tenant ID
    errors: {}, // Track error state by tenant ID
    // ...tenant-specific state and actions
    fetchTenants: async (page, pageSize) => {
      const data = await getTenants(page, pageSize);
      set((state) => {
        state.allTenants = data;
        // Also store in the tenant cache for quick access
        // Can't do this in this case
        // data.forEach((tenant) => {
        //   state.tenants[tenant.id] = tenant;
        // });
      });
      return data;
    },
    // Smart fetch - gets from cache or API
    fetchTenant: async (id, forceRefresh = false) => {
      // If we already have a complete tenant and don't need to refresh
      const existingTenant = get().tenants[id];
      if (existingTenant && !forceRefresh) {
        return existingTenant;
      }

      // Mark as loading
      set((state) => {
        state.loading[id] = true;
        state.errors[id] = null;
      });

      try {
        const data = await getTenant(id);
        set((state) => {
          state.tenants[id] = data;
          state.loading[id] = false;
        });
        return data;
      } catch (error) {
        set((state) => {
          state.errors[id] = error.message || "Failed to load tenant";
          state.loading[id] = false;
        });
        throw error;
      }
    },
    updateTenant: (id, data) =>
      set((state) => {
        if (!state.tenants[id]) state.tenants[id] = {};
        Object.assign(state.tenants[id], data);
      }),

    // Get loading state for a specific tenant
    isTenantLoading: (id) => get().loading[id] || false,

    // Get error state for a specific tenant
    getTenantError: (id) => get().errors[id] || null,
  }))
);
